export const SET_USER = "setUser";
export const SET_AUTH = "setAuth";
export const SET_VERSION = "setV";
export const SET_PRODUCTS = "setP";
export const SET_LOGOUT = "setLogout";
export const SET_COMMERCES_TYPES = "setCommercesTypes";
export const SET_USER_DATA = "setUserData";
export const SET_PROBLEMS_TYPES = "setProblemsTypes";
export const SET_STATES = "setStates";
// SETP
export const SET_SNR_OFFICES = "setSnrOffices";
export const SET_TRANSACTIONS = "setTransactions";
export const SET_CARRIERS = "setCarriers";
export const SET_PACKAGES = "setPackages";
export const SET_BAG = "setB";
export const SET_BAGS = "setBs";
export const SET_CUSTOMERS = "setCustomers";
export const SET_CATEGORIES = "setCategories";
export const SET_CASHFLOWS = "setCashflows";
export const SET_SEARCH = "SET_SEARCH";



// WEBPACK FOOTER //
// ./src/store/mutations.type.js